import axios from "axios";
import { config } from "../config/config";
import { Lesson } from "../types";

export const getLessons = async (): Promise<Lesson[]> => {
  try {
    const response = await axios.get(`${config.apiUrl}/lessons`);
    return response.data;
  } catch (error) {
    console.error("Error fetching lessons:", error);
    throw error;
  }
};

export const addLesson = async (lesson: {
  name: string;
  description: string;
}) => {
  try {
    const response = await axios.post(`${config.apiUrl}/lessons`, lesson, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("jwtToken")}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error adding lesson:", error);
    throw error;
  }
};
